module.exports = __webpack_public_path__ + "static/media/settings.369137d8.png";